import React, { useEffect, useState } from "react";
import {
   BrowserRouter as Router,
   Switch,
   Route,
} from "react-router-dom";
import About from "./Components/About/About";
import Blogs from "./Components/Blogs/Blogs";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import NotMatch from "./Components/NotMatch/NotMatch";
import ProjectDetails from "./Components/Projects/ProjectDetails";
import Projects from "./Components/Projects/Projects";
import Services from "./Components/Services/Services";
import { FaArrowUp } from "react-icons/fa";
function App() {

      const [show, handleShow] = useState(false);
    
      useEffect(() => {
        window.addEventListener('scroll', () => {
          if (window.scrollY > 50) {
            handleShow(true);
          } else handleShow(false);
        });
        return () => {
          window.removeEventListener('scroll');
        };
      }, []);
    
      const backToTop = () => {
        window.scroll({ top: 0, behavior: 'smooth' });
      };
   return (

      <>
         <Router>
         <Navbar />
            <Switch>
               <Route exact path="/">
                  <Home />
               </Route>
               <Route path="/home">
                  <Home />
               </Route>
               <Route path="/about">
                  <About />
               </Route>
               <Route path="/blogs">
                  <Blogs />
               </Route>
               <Route path="/projects">
                  <Projects />
               </Route>
               <Route path="/projectsDetails">
                  <ProjectDetails />
               </Route>
               <Route path="/services">
                  <Services />
               </Route>
               <Route path="/contact">
                  <Contact />
               </Route>
               <Route path="/details/:idd">
                  <ProjectDetails />
               </Route>
               <Route path="*">
                  <NotMatch />
               </Route>
            </Switch>
            {show &&<ul class="smothscroll" onClick={() => backToTop()}   ><li id="myBtn"><a href="#navbar"><FaArrowUp /></a></li></ul>
             }
            <Footer />
         </Router>
      </>
   );
}

export default App;

